import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../Wrapper/WrapperByRole'

const ManagerWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='manager' {...props} />

export default ManagerWrapper